
import { useState } from "react";
import { colors } from "oolib";
import { getPrimaryColor100 } from "oolib/dist/utilsOolib";

export const useResizeTableColumns = ({
  setColWidthConfig,
  colWidthConfig,
  theme,
  builderProps
}) => {

  const [colResizeState, setColResizeState] = useState(undefined)

const dragZoneWidth = 5;


const handleResizeColumn = (e) => {
  e.preventDefault()
  e.stopPropagation();
  if(colResizeState){
    setColWidthConfig(prev => {
      return ({
        ...prev,
        [colResizeState.colId]: (colResizeState.initWidth + (e.clientX - colResizeState.mousePos)) + 'px'
      })
    })
  }  
}


const resetDragZoneIndicator = ({
  e,
  borderStyleInactive = `1px solid ${colors.greyColor10}`
}) => {
  if(colResizeState || e.currentTarget.id !== e.target.id) return;
  e.currentTarget.style.borderRight = borderStyleInactive
  e.currentTarget.style.cursor = 'pointer'
}

const isInDragZone = e => {
  let mouseX = e.clientX;
  let {right: colRightEdge} = e.currentTarget.getBoundingClientRect();
  return mouseX > colRightEdge-dragZoneWidth;
}

const initColResizeState = (e, d) => {
  if(isInDragZone(e)){
    e.preventDefault() // these have to be inside isInDragZone, else clicking on cell wont allow rte to get focussed in SimpleTable
    e.stopPropagation();
    setColResizeState({
      mousePos: e.clientX,
      initWidth: parseInt(colWidthConfig[d.colId].replace('px', '')),
      colId: d.colId
    });
  }
 
}

const hideShowDragZoneIndicator = ({
  e, 
  borderStyleActive = `1px solid ${getPrimaryColor100(theme?.colors)}`, 
  borderStyleInactive = `1px solid ${colors.greyColor10}`
}) => {
  e.preventDefault()
  /** currentTarget is the element that this event is bound to */
  if(e.currentTarget.id !== e.target.id) return  //very important, else the indicator shows in some cases, when its not supposed to. we don't completely understand why...
  if(!colResizeState){
    if(isInDragZone(e)){
      e.currentTarget.style.borderRight = borderStyleActive
      e.currentTarget.style.setProperty('cursor','col-resize','important'); // using the setProperty approach only so that we can apply !important
    }else{
      e.currentTarget.style.borderRight = borderStyleInactive
      e.currentTarget.style.cursor = 'pointer'
    }
  } 
}

const resetColResizeState = e => {
  setColResizeState(undefined);
  if(builderProps?.updateColWidthsInTableConfig){
    builderProps.updateColWidthsInTableConfig(colWidthConfig)
  }
  
}

return ({
  resetColResizeState,
  hideShowDragZoneIndicator,
  initColResizeState,
  resetDragZoneIndicator,
  handleResizeColumn,
  colResizeState,
  dragZoneWidth
})
}